export default "<h1>Ooops..... Page Not Found</h1>\n"